import { FormularioFacturacionComponent } from './formulario-facturacion/formulario-facturacion.component';
import { ModalImageComponent } from './modal-image/modal-image.component';
import { OxxoPayComponent } from './oxxo-pay/oxxo-pay.component';
import { ModalRankingComponent } from './modal-ranking/modal-ranking.component';
import { CustomCard1Component } from './custom-card1/custom-card1.component';
import { CustomListToggleComponent } from './custom-list-toggle/custom-list-toggle.component';
import { CustomAnimationList1Component } from './custom-animation-list1/custom-animation-list1.component';
import { CustomAnimationList6Component } from './custom-animation-list6/custom-animation-list6.component';
import { CustomCard3Component } from './custom-card3/custom-card3.component';
import { CustomPaginationComponent } from './custom-pagination/custom-pagination.component';
import { CustomProductListComponent } from './custom-product-list/custom-product-list.component';
import { CustomProfile2Component } from './custom-profile2/custom-profile2.component';
import { CustomHeaderComponent } from './custom-header/custom-header.component';
import { CustomSideRightComponent } from './custom-side-right/custom-side-right.component';
import { RouterModule } from '@angular/router';
import { CustomSideMenuComponent } from './custom-side-menu/custom-side-menu.component';
import { CustomLoginComponent } from './custom-login/custom-login.component';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QRCodeComponent } from 'angularx-qrcode';
import { SpinnerComponent } from './spinner/spinner.component';
import { CustomProductCardComponent } from './custom-product-card/custom-product-card.component';
import { CustomCartButtonComponent } from './custom-cart-button/custom-cart-button.component';
import { OpenPayComponent } from './open-pay/open-pay.component';


@NgModule({
  declarations: [
    CustomLoginComponent,
    CustomSideMenuComponent,
    CustomSideRightComponent,
    CustomHeaderComponent,
    CustomProfile2Component,
    CustomProductListComponent,
    CustomPaginationComponent,
    CustomCard3Component,
    CustomAnimationList6Component,
    CustomAnimationList1Component,
    CustomListToggleComponent,
    CustomCard1Component,
    ModalRankingComponent,
    SpinnerComponent,
    OxxoPayComponent,
    ModalImageComponent,
    FormularioFacturacionComponent,    CustomProductCardComponent,
    CustomCartButtonComponent,
    OpenPayComponent,
  ],
  exports:[
    CustomLoginComponent,
    CustomSideMenuComponent,
    CustomSideRightComponent,
    CustomHeaderComponent,
    CustomProfile2Component,
    CustomProductListComponent,
    CustomPaginationComponent,
    CustomCard3Component,
    CustomAnimationList6Component,
    CustomListToggleComponent,
    CustomCard1Component,
    ModalRankingComponent,
    SpinnerComponent,
    OxxoPayComponent,
    ModalImageComponent,    FormularioFacturacionComponent,
    CustomProductCardComponent,
    CustomCartButtonComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    IonicModule.forRoot(),
    QRCodeComponent
  ],
})
export class ComponentsModule { }
